module.exports = __webpack_public_path__ + "static/HM-Government-G-Cloud-Supplierpng-7efde31bc79a92fdef77bc66fda95a78.png";